import { Button, FormInput } from '@basqet-dashboard/common/components';
import { InfoLabel, PepYesNoToggle, SidePanel } from '@components/onboarding';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

const PepLabel = () => (
  <InfoLabel
    text="Is this a Politically Exposed Person (PEP)?"
    tooltip="Politically exposed persons are people who hold or have held public office, or are closely related to someone who does. Select Yes only if this applies."
  />
);

const DirectorPanel = ({ entry, onSave, onClose }) => {
  const [name, setName] = useState(entry?.name || '');
  const [isPep, setIsPep] = useState(entry?.is_pep || '');
  const [bvn, setBvn] = useState(entry?.bvn || '');
  const [errors, setErrors] = useState({});

  const validate = () => {
    const errs = {};
    if (!name.trim()) errs.name = 'Name is required';
    if (!isPep) errs.is_pep = 'Please select an option';
    if (!/^\d{11}$/.test(bvn)) errs.bvn = 'BVN must be exactly 11 digits';
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSave = () => {
    if (!validate()) return;
    onSave({ name: name.trim(), is_pep: isPep, bvn });
  };

  return (
    <SidePanel title="Business Director" cursiveTitle="Details" onClose={onClose}>
      <div className="side-panel__body">
        <div className="side-panel__fields">
          <FormInput
            label="Name of Director"
            name="director_name"
            placeholder="First name, Last name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={errors.name}
          />
          <div>
            <PepLabel />
            <PepYesNoToggle value={isPep} onChange={setIsPep} />
            {errors.is_pep && <span className="corp-step-form__error">{errors.is_pep}</span>}
          </div>
          <FormInput
            label="BVN"
            name="director_bvn"
            placeholder="e.g 1234567890"
            value={bvn}
            onChange={(e) => setBvn(e.target.value)}
            error={errors.bvn}
          />
        </div>
      </div>
      <div className="side-panel__footer">
        <Button isFull onClick={handleSave}>
          Save and Continue
        </Button>
      </div>
    </SidePanel>
  );
};

DirectorPanel.propTypes = {
  entry: PropTypes.object,
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired
};

export { DirectorPanel };
